import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Calendar, ArrowUpRight } from "lucide-react";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/posts").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="journal-page" className="max-w-5xl mx-auto px-6 md:px-10 py-16 md:py-24">
      <div className="overline mb-4">Daily journal</div>
      <h1 className="font-serif-display text-5xl md:text-6xl leading-none mb-4">
        Notes from<br /><em className="italic text-[var(--forest)]">the road.</em>
      </h1>
      <p className="text-[var(--ink-soft)] text-lg max-w-2xl leading-relaxed mb-14">
        Written reflections by Rick or Stephanie focusing on the highlights of their journey,
        confessing the struggle they&apos;ve endured, and sharing the success of another life saved
        <span className="ml-1">🙏</span>
      </p>

      {posts.length === 0 ? (
        <div className="text-center py-20 text-[var(--ink-soft)]">
          No journal entries yet — the first one is being written.
        </div>
      ) : (
        <div className="space-y-10">
          {posts.map((p) => (
            <article key={p.id} data-testid={`journal-${p.slug}`} className="grid md:grid-cols-12 gap-6 border-b border-[var(--line)] pb-10">
              {p.image_url && (
                <div className="md:col-span-4">
                  <Link to={`/journal/${p.slug}`}>
                    <img src={p.image_url} alt={p.title} className="w-full aspect-[4/3] object-cover rounded-sm" />
                  </Link>
                </div>
              )}
              <div className={p.image_url ? "md:col-span-8" : "md:col-span-12"}>
                <div className="inline-flex items-center gap-1.5 text-xs font-mono-acc text-[var(--ink-soft)] mb-3">
                  <Calendar className="w-3 h-3" />{(p.created_at || "").slice(0, 10)}
                </div>
                <h2 className="font-serif-display text-3xl md:text-4xl mb-3 leading-tight">
                  <Link to={`/journal/${p.slug}`} className="hover:text-[var(--forest)] transition">{p.title}</Link>
                </h2>
                {p.excerpt && <p className="text-[var(--ink-soft)] leading-relaxed mb-4">{p.excerpt}</p>}
                <Link to={`/journal/${p.slug}`} data-testid={`journal-read-${p.slug}`}
                  className="inline-flex items-center gap-1.5 text-sm text-[var(--forest)] hover:underline">
                  Read full entry <ArrowUpRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
